import type { HubMetricConfig, HubMetricSource } from "@expert/app-config";

import type { MetricBucket } from "./types";

type DataverseSource = Extract<HubMetricSource, { kind: "dataverse" }>;
type DataverseCard = HubMetricConfig & { source: DataverseSource };

export const isDataverseCard = (card: HubMetricConfig): card is DataverseCard => card.source.kind === "dataverse";

export function getMetricValue(bucket: MetricBucket | null | undefined, key: string): number | null {
    return bucket?.[key]?.calc ?? null;
}
